<script>
import { getRolename  }  from "@/helpers/helper"

export default {
  name: 'History',
  props:[
    "data",
    "openModal"
  ],
  components: {
  },
  data() {
    return {
        title:'',
        url:'/stock/history/movements',
        submitted: false,
        odemeData:{},
        isLoading: false,
        rows: [],
        totalRecords: 0,
        serverParams: {
          columnFilters: {},
          sort: [
            {
              field: '',
              type: '',
            },
          ],
          page: 1,
          perPage: 50,
        },
        currentPage: 0,
        pageLength: 0,
        columns:[
          { label: 'Hareket Tipi', field: 'movement_type', sortable: false },
          { label: 'Nereden', field: 'source_name', sortable: false },
          { label: 'Nereye', field: 'destination_name', sortable: false },
          { label: 'Grup', field: 'stock_group_name', sortable: false },
          { label: 'Ürün', field: 'stock_name', sortable: false },
          { label: 'Açıklama', field: 'description', sortable: false },
          { label: 'Miktar', field: 'amount', sortable: false },
          { label: 'İşlem Tarihi', field: 'created_at', sortable: false, width: '200px' },
        ]
    }
  },
    watch:{
      openModal(){
        this.rows = []
        // Use unified movements endpoint and provide filters via serverParams
        this.url = `/stock/history/movements`
        // ensure columnFilters contains stock_group_id and user_id when available
        this.serverParams = {
          ...this.serverParams,
          columnFilters: {
            ...(this.serverParams.columnFilters || {}),
            stock_group_id: this.data && this.data.stock_group_id ? this.data.stock_group_id : null,
            user_id: this.data && this.data.user_id ? this.data.user_id : null,
          }
        }
        this.loadItems()
      }
    },
  computed:{
    rolename(){
      return getRolename()
    }
  },
  methods: {
    subs(obj){
       return (obj.username ?? '') + ' - ' + (obj.fname ?? '') + ' ' + (obj.lname ?? '');
    },
    updateParams(newProps) {
      this.serverParams = { ...this.serverParams, ...newProps }
    },
    onPageChange(params) {
      this.updateParams({ page: params.currentPage })
      this.loadItems()
    },
    onPerPageChange(params) {
      this.updateParams({ perPage: params.currentPerPage })
      this.loadItems()
    },
    onSortChange(params) {
      this.updateParams({
        sort: params,
      })
      this.loadItems()
    },
    onColumnFilter(params) {
      this.updateParams(params)
      this.loadItems()
    },
    loadItems() {
      this.getFromServer(this.serverParams).then(response => {
        this.totalRecords = response.totalRecords
        this.pageLength = response.pageLength
        this.currentPage = response.currentPage
        // Format rows to be more user-friendly (labels, amounts, dates)
        this.rows = (response.rows || []).map(r => ({
          ...r,
          movement_type: this.movementLabel(r.movement_type),
          amount: this.formatAmountWithUnit(r.amount, r.unit),
          created_at: this.formatDate(r.created_at)
        }))
      })
    },
    getFromServer() {
        return new Promise((resolve) => {
            this.$http.post(this.url, this.serverParams)
            .then(res => {
                resolve({
                  rows: res.data.data,
                  totalRecords: res.data.total,
                  pageLength: res.data.last_page,
                  currentPage: res.data.current_page,
                })
            })
        })
    },

    close(){
      this.$parent.$bvModal.hide('history')
    },

    movementLabel(type) {
      if (!type) return '';
      const map = {
        'sale': 'Satış',
        'return': 'İade',
        'transfer_to_depot': 'Depo Transferi',
        'created': 'Oluşturuldu',
        'added': 'Eklendi',
        'attached_to_subscription': 'Müşteriye Atama',
        'attached_to_transmitter': 'Vericiye Gönderim',
        'attached_to_transmitter_group': 'POP Noktasına Gönderim',
        'defective_return': 'Arıza İade',
        'marked_defective': 'Arızalı İşaretleme',
        'unknown': 'Bilinmeyen',
      };
      return map[type] || type;
    },
    formatAmount(value) {
      if (value === null || value === undefined || value === '') return '';
      const n = parseFloat(value);
      if (Number.isNaN(n)) return value;
      return Number.isInteger(n) ? n.toString() : n.toString();
    },
    formatAmountWithUnit(value, unit) {
      const amt = this.formatAmount(value);
      if (!unit) return amt;
      return `${amt} ${unit}`;
    },
    formatDate(val){
      if(!val) return '';
      const d = new Date(val);
      if (isNaN(d.getTime())) return val;
      const pad = (n)=> n.toString().padStart(2,'0');
      return `${pad(d.getDate())}.${pad(d.getMonth()+1)}.${d.getFullYear()} ${pad(d.getHours())}:${pad(d.getMinutes())}`;
    }


  },
};
</script>

<template>
  <b-modal id="history" size="xl" title="Depo Hareketleri"  no-close-on-backdrop hide-footer>
    <div class="row">
      <div class="col-12">
        <div class="card">
             <vue-good-table
                mode="remote"
                :total-rows="totalRecords"
                :columns="columns"
                :rows="rows"
                :search-options="{ enabled: false }"
                :is-loading.sync="isLoading"
                @on-page-change="onPageChange"
                @on-sort-change="onSortChange"
                @on-column-filter="onColumnFilter"
                @on-per-page-change="onPerPageChange">
                <template slot="loadingContent">
                  <div>Yükleniyor</div>
                </template>
            </vue-good-table>
        </div>
      </div>
    </div>
</b-modal>
</template>